/* eslint-disable no-console */
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common.Accept = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  process.env.REACT_APP_PROJECT_URL;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
